import { __assign } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { ClickIcon, TapIcon } from './icons';
import styles from './PlayButton.module.css';
export default function PlayButton(_a) {
    var _b;
    var hasTouch = _a.hasTouch, isAppleWatch = _a.isAppleWatch, isLoading = _a.isLoading, onClick = _a.onClick;
    var icon = hasTouch ? React.createElement(TapIcon, null) : React.createElement(ClickIcon, null);
    var action = hasTouch ? 'Tap' : 'Click';
    var message = action + " anywhere to interact with this prototype";
    var size = hasTouch ? 28 : 26;
    var boxClasses = cx(styles.box, (_b = {},
        _b[styles.fontBig] = !isAppleWatch,
        _b[styles.fontSmall] = isAppleWatch,
        _b[styles.loading] = isLoading && isAppleWatch,
        _b));
    var loadingProps = {
        className: styles.loading,
        style: { width: size, height: size },
    };
    var messageStyle = {
        opacity: isLoading && isAppleWatch ? 0 : 1,
    };
    return (React.createElement("div", { className: styles.position, onClick: onClick },
        React.createElement("div", { className: styles.table },
            React.createElement("div", { className: styles.cell },
                React.createElement("div", { className: boxClasses },
                    !isAppleWatch && (React.createElement("div", { className: styles.icon }, isLoading ? React.createElement("div", __assign({}, loadingProps)) : icon)),
                    React.createElement("div", { style: messageStyle }, message))))));
}
PlayButton.propTypes = {
    hasTouch: PropTypes.bool.isRequired,
    isAppleWatch: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};
PlayButton.defaultProps = {
    hasTouch: false,
    isAppleWatch: false,
    isLoading: false,
};
